import * as Sentry from '@sentry/browser'

export function menuSPRouter(menu, SPRouter) {
  const matchingElements = []
  menu.forEach(element => {
    SPRouter.forEach(item => {
      let obj = {}
      if (element.secondMenus && item.children) {
        const childMatches = menuSPRouter(element.secondMenus, item.children)
        obj.secondMenus = childMatches
      }
      if (element.name.indexOf(item.display_name) != -1) {
        obj = { ...item, ...element, ...obj }
        matchingElements.push(obj)
      }
    })
  })
  return matchingElements
}

export async function getMenuList(content) {
  const data = await content.$api.user.getPermission(0)
  content.$store.state.spRouter = data
  let menu = null
  switch (content.$store.state.user.userInfo?.type) {
    case content.$api.account.types.STUDENT.value:
      menu = content.$route.matched[0].meta.student.menu
      break
    case content.$api.account.types.TEACHER.value:
      menu = content.$route.matched[0].meta.teacher.menu
      break
    case content.$api.account.types.SCHOOL_ADMIN.value:
      menu = content.$route.matched[0].meta.school_admin.menu
      break
    case content.$api.account.types.PLATFORM_ADMIN.value:
      menu = content.$route.matched[0].meta.platform_admin.menu
      break
    default:
      menu = content.$route.matched[0].meta.other.menu
      menu = menuSPRouter(menu, content.$store.state.spRouter)
      break
  }
  content.$store.state.menu = menu
  localStorage.setItem('vuex.menu', JSON.stringify(menu))
}


export async function loginPreOperation(content) {
  await getMenuList(content)
  const id = content.$store.state?.user?.userInfo?.id
  const loginName = content.$store.state?.user?.userInfo?.login_name
  Sentry.setUser({ id, 'Login Name': loginName })
  switch (content.$store.state.user.userInfo.type) {
    case content.$api.account.types.TEACHER.value:
      content.$router.push('/workbench/classgrade_mgn').catch(err => {})
      break
    case content.$api.account.types.SCHOOL_ADMIN.value:
      content.$router.push('/workbench/classgrade_mgn').catch(err => {})
      break
    case content.$api.account.types.PLATFORM_ADMIN.value:
      content.$router.push('/workbench').catch(err => {})
      break
    case content.$api.account.types.RESEARCH.value:
      content.$router.push('/workbench/teachingManagement')
      break;
    default:
      try {
        const menu = content.$store.state.menu[0]
        let path
        const getPath = (data) => {
          if (data.path) {
            path = data.path
          } else {
            getPath(data.children[0])
          }
        }
        getPath(menu)
        content.$router.push(path)
      } catch (err) {
        content.$message('无权限访问')
        content.$router.push('/login')
      }
      break;
  }
}
